import {Plugin} from "ckeditor5";
import {ButtonView} from "ckeditor5";
import {environment} from "../../../../../environments/environment";
import {AiService} from "../../../../features/admin/data-access/ai.service";

export class QundisGpt extends Plugin {
  static aiService: AiService;
  toolbarIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cpu" viewBox="0 0 16 16">\n' +
    '  <path d="M5 0a.5.5 0 0 1 .5.5V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2A2.5 2.5 0 0 1 14 4.5h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14a2.5 2.5 0 0 1-2.5 2.5v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14A2.5 2.5 0 0 1 2 11.5H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2A2.5 2.5 0 0 1 4.5 2V.5A.5.5 0 0 1 5 0m-.5 3A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3zM5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5zM6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z"/>\n' +
    '</svg>';

  init() {
    const editor = this.editor;
    editor.ui.componentFactory.add('QundisGPT', locale => {
      const view = new ButtonView(locale);
      view.set({
        label: environment.editorAiPluginLabel,
        tooltip: true,
        withText: false,
        icon: this.toolbarIcon
      });

      view.on('execute', async () => {
        view.isEnabled = false;
        try {
          const inputText = editor.getData();
          const structuredText = await QundisGpt.aiService.generateSolution(inputText);
          editor.fire('qundisGptResponse', structuredText);
        } catch (e) {
          console.error(e);
          editor.fire(
            'qundisGptResponse',
            `<p><em>Fehler beim Formatieren: ${(e as Error).message}</em></p>`
          );
        } finally {
          view.isEnabled = true;
        }
      });
      return view;
    });
  }
}
